import { FunctionComponent } from 'react';
import { KycReviewStatus } from './enums/KycReviewStatus';
import { StatusKYCStepOne } from './enums/StatusKYCStepOne';
import { StatusKYCStepTwo } from './enums/StatusKYCStepTwo';
import { CardStepOne } from './card-step/card-step-one';
import { CardStepTwo } from './card-step/card-step-two';

import './styles.scss';

interface getStatusStepProps {
  level: number;
  validKYC: boolean;
  kycReview: boolean;
  kycReviewStatus: KycReviewStatus | null;
}

const getStatusStepOne = ({ level, validKYC, kycReviewStatus }: getStatusStepProps): StatusKYCStepOne => {
  if (kycReviewStatus === KycReviewStatus.REJECTED_BY_WEBSITE) {
    return StatusKYCStepOne.REJECTED_BY_WEBSITE;
  }
  if (kycReviewStatus === KycReviewStatus.REJECTED_BY_INDUSTRY) {
    return StatusKYCStepOne.REJECTED_BY_INDUSTRY;
  }
  if ((level === 1 && validKYC) || level > 1) {
    return StatusKYCStepOne.COMPLETED;
  }
  return StatusKYCStepOne.ENABLED;
};

const getStatusStepTwo = ({ level, validKYC, kycReview, kycReviewStatus }: getStatusStepProps): StatusKYCStepTwo => {
  if (kycReview) {
    return StatusKYCStepTwo.PENDING_APPROVAL;
  }
  if (kycReviewStatus === KycReviewStatus.REJECTED_BY_DOCUMENTATION) {
    return StatusKYCStepTwo.REJECTED_BY_DOCUMENTATION;
  }
  if (kycReviewStatus === KycReviewStatus.REJECTED_BY_WEBSITE) {
    return StatusKYCStepTwo.REJECTED_BY_WEBSITE;
  }
  if (kycReviewStatus === KycReviewStatus.REJECTED_BY_INDUSTRY) {
    return StatusKYCStepTwo.REJECTED_BY_INDUSTRY;
  }
  if (level === 4 && validKYC) {
    return StatusKYCStepTwo.COMPLETED;
  }
  if (level === 1 && !validKYC) {
    return StatusKYCStepTwo.PENDING;
  }
  return StatusKYCStepTwo.ENABLED;
};

interface KYCStepsProps {
  level: number;
  validKYC: boolean;
  kycReview: boolean;
  kycReviewStatus: KycReviewStatus | null;
  limitStepOne: number;
  onClick: (step: number) => void;
}

const KYCSteps: FunctionComponent<KYCStepsProps> = ({
  level,
  validKYC = false,
  kycReview = false,
  kycReviewStatus,
  limitStepOne,
  onClick,
}) => {
  const stepOneStatus = getStatusStepOne({ level, validKYC, kycReviewStatus, kycReview });
  const stepTwoStatus = getStatusStepTwo({ level, validKYC, kycReviewStatus, kycReview });

  return (
    <div className="card_steps">
      <CardStepOne statusKycStepOne={stepOneStatus} onClick={onClick} limitStepOne={limitStepOne} />
      <CardStepTwo statusKycStep2={stepTwoStatus} onClick={onClick} limitStepOne={limitStepOne} />
    </div>
  );
};

export default KYCSteps;
